import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { ThemeProvider } from 'styled-components/macro';

import adriagateRegistracijaImg from 'assets/img/ag_register.svg';
import { Grid } from 'common/components';
import { AdriagateStyled } from 'common/components/styled/Adriagate.styled';
import { Flex } from 'components/styled/Flex';
import RegistrationHeader from 'components/styled/RegistrationHeader';
import { adriagateTheme } from 'services/theme/Adriagate/adriagateTheme';

import { AdriagateLogo } from '../components/AdriagateLogo';
import { SignUpRenterForm } from '../components/SignUpRenterForm';
import { Welcome } from '../components/Welcome';
import { useTheme } from 'styled-components';

export const SignUpAdriagate = () => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery({ minWidth: 1200 }); // xl breakpoint
  const [openRegisterForm, setOpenRegisterForm] = useState(false);
  const { colors } = useTheme();

  const registerStep = (
    <>
      <RegistrationHeader mb={!isDesktop}>{t('Submit')}</RegistrationHeader>
      <SignUpRenterForm />
      {!isDesktop && (
        <Flex margin="1rem 0 2rem">
          <AdriagateLogo width="8rem" height="2.75rem" fill={colors.white} />
        </Flex>
      )}
    </>
  );

  const welcomeStep = (
    <>
      <Welcome setOpenRegisterForm={setOpenRegisterForm} />
    </>
  );

  return (
    <ThemeProvider theme={adriagateTheme}>
      <AdriagateStyled>
        <Grid style={{ width: '100%', height: '100vh' }} $columns={isDesktop ? 2 : 1}>
          {isDesktop && (
            <Flex width="100%">
              <img
                style={{
                  position: 'absolute',
                  left: 0,
                  height: '100vh',
                }}
                src={adriagateRegistracijaImg}
                alt="Adriagate registracija"
              />
            </Flex>
          )}
          <Flex
            style={isDesktop ? { position: 'relative', right: '8rem', overflow: 'auto' } : {}}
            width="100%"
            flexDirection="column"
            alignItems={isDesktop ? 'flex-start' : 'center'}
          >
            <Flex width="100%" flexDirection="column" margin="auto" alignItems="center">
              {!isDesktop ? (openRegisterForm ? registerStep : welcomeStep) : registerStep}
            </Flex>
          </Flex>
        </Grid>
      </AdriagateStyled>
    </ThemeProvider>
  );
};
